import TopToolbar from "./TopToolbar";
import withResponsiveUtils from "../../utils/ResponsiveUtils";

export default withResponsiveUtils(TopToolbar);
